var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"tooltip bg-warning",attrs:{"title":_vm.title}},[_c('i',{staticClass:"fa fa-question"})])}
var staticRenderFns = []

export { render, staticRenderFns }